// import React from "react";
import "./PGSecurityOneHome.scss";
// import SecurityOneVideoSection from "../securityOneComponent/SecurityOneVideoSection";
// import SecurityOneNewVisitorPhoneNumber from "../securityOneComponent/SecurityOneNewVisitorPhoneNumber";
import { useNavigate } from "react-router-dom";
import SecurityOneQuickMenus from "../securityOneComponent/SecurityOneQuickMenus";
import HomeHeroBanners from "../../../../default-components/HomeHeroBanners";
const SecurityOneHome = () => {
  const navigate = useNavigate();
  return (
    <div>
      {/* <SecurityOneVideoSection />
      <SecurityOneNewVisitorPhoneNumber />
      <div className="large_margin_div"></div> */}
      <div className="security-one-home-container">
        <div className="security-one-home-banner">
          <HomeHeroBanners
            category="banner"
            pageName="home"
            section="homeherobanners"
            addMoreVideosButton={false}
            addMoreTextContentButton={false}
          />
          {/* <img
            src="https://cdn.grabon.in/gograbon/images/web-images/uploads/1617092437646/hotel-offers.jpg"
            alt="Banner"
            className="security-one-home-banner-img"
          /> */}
        </div>

        {/* SEARCH SECTION START */}
        <div className="security-one-home-search">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="gray"
          >
            <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" />
          </svg>
          <input
            type="search"
            autoComplete=""
            placeholder="Search visitors by name, phone number"
          />
        </div>
        {/* SEARCH SECTION END */}

        <SecurityOneQuickMenus />

        <div className="security-one-home-balance-refer">
          <div>
            <span className="material-symbols-outlined">beach_access</span>
            Holiday List
          </div>
          <div>
            <span className="material-symbols-outlined">card_giftcard</span>
            Refer & Win
          </div>
        </div>

        {/* UPCOMING VISITORS CODE START */}
        <div className="security-one-home-section-title">VISITORS</div>
        <div className="security-one-home-upcoming-visitors">
          {[
            { name: "Shyam", icon: "D", color: "#d84315" },
            {
              name: "Rajesh",
              image:
                "https://img.freepik.com/premium-photo/portrait-happy-young-casual-man-standing_171337-29744.jpg?w=740",
            },

            { name: "Anku", icon: "A", color: "#4caf50" },
            {
              name: "Rohan",
              image:
                "https://img.freepik.com/premium-photo/young-man-formal-clothes_21730-2120.jpg",
            },
            {
              name: "Krinya",
              image:
                "https://static.vecteezy.com/system/resources/previews/017/774/158/non_2x/portrait-of-smiling-beautiful-business-asian-woman-in-pink-suit-working-in-home-office-desk-using-computer-business-people-employee-freelance-online-marketing-e-commerce-work-from-home-concept-photo.jpg",
            },
            { name: "Jain", icon: "J", color: "#90a4ae" },
            {
              name: "Ananya",
              image:
                "https://img.freepik.com/premium-photo/young-smart-indian-businesswoman-smiling-face-standing-blur-background-busy-office-generative-ai-aig20_31965-158596.jpg",
            },
            {
              name: "More",
              icon: "keyboard_arrow_down",
              color: "#000000ab",
              isIcon: true,
            },
          ].map((visitor, index) => (
            <div className="security-one-home-visitor" key={index}>
              {visitor.image ? (
                <img src={visitor.image} alt={visitor.name} />
              ) : visitor.isIcon ? (
                <div
                  className="icon-avatar"
                  style={{ background: visitor.color }}
                >
                  <span className="material-symbols-outlined">
                    {visitor.icon}
                  </span>
                </div>
              ) : (
                <div
                  className="initial-avatar"
                  style={{ background: visitor.color }}
                >
                  {visitor.icon}
                </div>
              )}
              <div className="security-one-home-visitor-name">
                {visitor.name}
              </div>
            </div>
          ))}
        </div>
        {/* UPCOMING VISITORS CODE END */}

        <div className="security-one-home-section-title">DISCOVER</div>
        <div className="security-one-home-recharges">
          <div className="security-one-home-recharges-item">
            <span className="material-symbols-outlined">person</span>
            Profile
          </div>
          <div className="security-one-home-recharges-item">
            <span className="material-symbols-outlined">notifications</span>
            Notifications
          </div>
          <div className="security-one-home-recharges-item">
            <span className="material-symbols-outlined">settings</span>
            Settings
          </div>
          <div className="security-one-home-recharges-item">
            <span className="material-symbols-outlined">warning</span>
            Support
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityOneHome;
